import React, { useState, useEffect, forwardRef, useRef } from 'react';

import { Swiper, SwiperProps, SwiperRef, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Scrollbar, Autoplay, FreeMode, Thumbs } from 'swiper/modules';

import './SwiperSlider.scss';

type Props = {
  containerClass?: string;
  children: JSX.Element[];
  classes?: string;
} & SwiperProps;

const SwiperSlider = forwardRef(({ ...props }: Props, ref: React.Ref<SwiperRef>) => {
  const { children, containerClass, ...swiperProps } = props;
  const swiperRef = useRef<HTMLDivElement>(null);
  const [isAboveTheFold, setIsAboveTheFold] = useState(false);

  useEffect(() => {
    const checkIfAboveTheFold = () => {
      if (!swiperRef.current) return;
      const viewportHeight = window.innerHeight;
      const rect = swiperRef.current.getBoundingClientRect();
      setIsAboveTheFold(rect.top < viewportHeight);
    };

    checkIfAboveTheFold();
    window.addEventListener("scroll", checkIfAboveTheFold);
    window.addEventListener("resize", checkIfAboveTheFold);

    return () => {
      window.removeEventListener("scroll", checkIfAboveTheFold);
      window.removeEventListener("resize", checkIfAboveTheFold);
    };
  }, []);

  return (
    <div className={`swiper-container ${containerClass || ''}`}>
      <Swiper
        ref={ref}
        {...swiperProps}
        modules={[Navigation, Pagination, Scrollbar, Autoplay, FreeMode, Thumbs]}
      >
        {children.map((slide) => (
          <SwiperSlide key={slide.key}>{slide}</SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
});

export default SwiperSlider;
